import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FieldText, lovLabel, FormProps, ClosedContentProps, lovParam} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {PrimaryKeyString} from 'core/form/rules';
import {EVENTCATEGORY, EventType} from "core/event/eventDomain";
import {observer} from "mobx-react";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";
import {action} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";


@observer
class EventTypeForm extends React.Component<FormProps<EventType, EventType>, undefined> {

  render() {


    let {dataObject, rootObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(definition.formName);
    let {eventTypeId, eventName, comment, eventType, eventCategory, smsDeliveryReceipt, smsDeliveryFailureAlert} = fields;

    let openContent = (
      <div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...eventTypeId.props} disabled={!dataObject.$new} autoFocus />
            <Validate field={eventTypeId} value={eventTypeId.props.value}>
              <PrimaryKeyString/>
            </Validate>
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...eventName.props} />
            <Validate field={eventName} value={eventName.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-6">
            <StyledSelect {...eventType.props} />
            <Validate field={eventType} value={eventType.props.value} onSuccess={this.eventTypeOnSuccess}/>
          </div>
          <div className="fx col-xs-6 col-sm-6">
            <StyledSelect {...eventCategory.props} />
            <Validate field={eventCategory} value={eventCategory.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-6">
            <MdCheckbox {...smsDeliveryReceipt.props} />
          </div>
          <div className="fx col-xs-6 col-sm-6">
            <StyledSelect {...smsDeliveryFailureAlert.props} options={smsDeliveryFailureAlert.props.options.filter(lov =>  ((lov["eventCategory"] === EVENTCATEGORY.EMAIL_EVENT || lov["eventCategory"] === EVENTCATEGORY.SMS_EVENT)) || !lov.value )} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={2}  />
          </div>
        </div>

      </div>
    );



    return (
      <BlockComp noPadding >
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }

  @action eventTypeOnSuccess = () => {
    let {dataObject, form} = this.props;
    if (!dataObject.eventCategory && dataObject.eventType) {
      dataObject.eventCategory =  mdEntityService.getEntity("EVENTCATEGORY").getLovItem(lovParam(dataObject.eventType, "defaultEventCategory")) ;
      form.updateFieldsPropValue(dataObject, "eventCategory");
    }
  }

}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<EventType>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>

    <h5 style={{marginTop: 0, fontSize: '18px', fontWeight: 'bold'}}> <span className="zz-grey-text">{lovLabel(dataObject.eventType)}</span> {dataObject.eventName}</h5>

    <div className="form-text-row">
      <FieldText label={fields.eventCategory.textLabel} value={dataObject.eventCategory}/>
      <FieldText label={fields.eventTypeId.textLabel} value={dataObject.eventTypeId}/>
    </div>
    <div className="form-text-row">
      <FieldText label={fields.smsDeliveryFailureAlert.textLabel} value={dataObject.smsDeliveryFailureAlert}/>
    </div>

    <div className="form-text-row">
      { (dataObject.smsDeliveryReceipt) ? fields.smsDeliveryReceipt.textLabel : '' }
    </div>

    <div className="form-text-row">
      <FieldText label={fields.comment.textLabel} value={dataObject.comment}/>
    </div>

  </div>
);

const definition: DefinitionType = {
  formName: 'EventTypeForm',
  fields: [{
    name: 'eventTypeId',
    validators: ['IsRequired']
  }, {
    name: 'eventName',
    validators: ['IsRequired']
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'smsDeliveryReceipt',
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }, {
    name: 'eventType',
    validators: ['IsRequired']
  }, {
    name: 'eventCategory',
    validators: ['IsRequired']
  },{
    name: 'smsDeliveryFailureAlert'
  }]
};

export default createForm(definition, ClosedContent)(EventTypeForm);




// WEBPACK FOOTER //
// ./src/core/event/component/eventTypeForm.tsx